import differenceInWeeks from 'date-fns/difference_in_weeks';
import NotificationLogService from './NotificationLogService';
import { toISOStringNoZone } from '../../lib/dataLayer/util';

export const getNotificationTimeEntries = id =>
  NotificationLogService.getById(id).then(notificationTimes => {
    return notificationTimes || [];
  });

export const updateNotificationLog = id => {
  const now = toISOStringNoZone(new Date());
  return getNotificationTimeEntries(id).then(notificationTimes => {
    const prunedEntries = notificationTimes.filter(
      timeEntry => differenceInWeeks(now, timeEntry) < 1,
    );
    const updatedTimeEntries = [...prunedEntries, now];
    return NotificationLogService.update(id, updatedTimeEntries);
  });
};



// WEBPACK FOOTER //
// ./src/store/notificationLog/index.js